export default __webpack_public_path__ + "12265d3f43fef93ce74a5696304ff35f.svg";